import type { FC } from 'react'
import { PersonRiderIcon, Tag, TagStyle, TagVariant } from '@/tools/ui'

interface Props {
  deliveryFee: {
    baseFee: string
    effectiveFee?: string
    isPrimeDeliveryFee?: boolean
    isSurged?: boolean
    isFreeDeliveryFee?: boolean
    isDiscountedDeliveryFee?: boolean
  }
}

export const StoreDeliveryFeeTag: FC<Props> = ({ deliveryFee }) => {
  const tagStyle =
    deliveryFee.isFreeDeliveryFee || deliveryFee.isDiscountedDeliveryFee
      ? { style: TagStyle.promotion, variant: TagVariant.primary }
      : { style: TagStyle.critical, variant: TagVariant.secondary }

  return (
    <>
      {deliveryFee.effectiveFee && (
        <Tag
          label={deliveryFee.effectiveFee}
          leadingIcon={PersonRiderIcon}
          style={tagStyle.style}
          variant={tagStyle.variant}
        />
      )}
    </>
  )
}
